try {
  var util = require('util');
  if (typeof util.inherits !== 'function') throw '';
  module.exports = util.inherits;
} catch (e) {
  module.exports = require('./inherits_browser.js');
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/inherits/inherits.js
// module id = ../node_modules/inherits/inherits.js
// module chunks = 5